import Sugar from "sugar";
const utils = {};

utils.intoReadableAmount = function (amount) {
    let finalAmount = 0;
    if (amount != null) {
        if (amount / 100000 < 1) {
            return `₹ ${Sugar.Number.format(amount)}`;
        } else {
            if (amount / 10000000 < 1) {
                finalAmount = amount / 100000;
                return "₹ " + finalAmount + " Lakh";
            } else {
                finalAmount = amount / 10000000;
                return "₹ " + finalAmount + " Cr";
            }
        }
    } else {
        return 'NA';
    }
}

utils.isMobile = function (mobileNumber) {
    return (mobileNumber > 999999999 && mobileNumber <= 9999999999)
}

utils.isPincode = function (pincode) {
    return /^[0-9]{6}$/.test(pincode)
}

utils.isPAN = function (pan) {
    return /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]$/.test(pan)
}

export default utils;


// WEBPACK FOOTER //
// ./src/utils/number.js